<template>
  <div class="order-thumb">
    <div class="days">
      <el-dropdown trigger="click" @command="changeDays">
        <span class="el-dropdown-button">
          {{ days }}Day<i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="7">7Day</el-dropdown-item>
            <el-dropdown-item command="15">15Day</el-dropdown-item>
            <el-dropdown-item command="30">30Day</el-dropdown-item>
            <el-dropdown-item command="60">60Day</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="changes-in" v-for="item in changesInList" :key="item.id">
      <p class="changes-in-label">{{ item.label }}</p>
      <p class="changes-in-value">
        <span class="numerical-value">{{ item.value }}</span>
        <span class="rise" v-if="item.rise">
          <i class="el-icon-caret-top"></i>
          {{ item.percent }}%
        </span>
        <span class="fall" v-else>
          <i class="el-icon-caret-bottom"></i>
          {{ item.percent }}%
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            days: "30",
            changesInList: [
                {
                    id: 1,
                    label: "Orders",
                    value: "0",
                    percent: "0",
                    rise: true,
                },
                {
                    id: 2,
                    label: "Ordered Items",
                    value: "0",
                    percent: "0",
                    rise: true,
                },
                {
                    id: 3,
                    label: "Returned Items",
                    value: "0",
                    percent: "0",
                    rise: true,
                },
                {
                    id: 4,
                    label: "Order Shipped",
                    value: "0",
                    percent: "0",
                    rise: true,
                },
                {
                    id: 5,
                    label: "Delivery Time",
                    value: "0",
                    percent: "0",
                    rise: false,
                },
            ],
        };
    },
    methods:{
        changeDays(ins){
            this.days = ins;
            this.getStatByDays();
        },
        getStatByDays(){
            cmofferApi.statByDays({ day: this.days }).then(res=>{
                // console.log('res: ', res);
                if(res){
                    let { orderNum, shippedNum, skuSpeciesNum } = res.data;
                    this.changesInList[0].value = orderNum;
                    this.changesInList[1].value = skuSpeciesNum;
                    this.changesInList[3].value = shippedNum;
                }
            })
        }
    },
    created(){
        this.getStatByDays();
    }
};
</script>

<style lang="scss" scoped>
$text-color: #a7bdc6;
.order-thumb {
  width: calc(100% - 30px);
  height: 60px;
  border-radius: 6px;
  background-color: #1f1f25;
  display: flex;
  margin: 0 15px 15px;
  font-size: 14px;
  color: $text-color;
  overflow: hidden;
  & > div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    padding: 0 10px 0 12px;
    text-align: left;
    &:not(:last-child) {
      border-right: 1px solid #111114;
    }
  }
  .days {
    min-width: 50px;
    width: 100px;
    ::v-deep .el-dropdown {
      text-align: center;
      .el-dropdown-button {
        font-size: 12px;
        color: $text-color;
        cursor: pointer;
        width: 100%;
        display: block;
        padding: 10px 0;
        .el-icon-caret-bottom {
          margin-left: 6px;
        }
      }
    }
  }
  .changes-in {
    min-width: 200px;
    .changes-in-label {
      margin-bottom: 8px;
      font-size: 12px;
    }
    .changes-in-value {
      .numerical-value {
        font-weight: 600;
      }
      .rise,
      .fall {
        font-size: 12px;
        margin-left: 8px;
      }
      .rise {
        color: #f04e61;
      }
      .fall {
        color: #039b85;
      }
    }
  }
}
</style>
